export default "__VITE_ASSET__97nRO9kz__"